import axiosInstance from '@/core/api'
import {
	GetEventsRequest,
	GetEventsResponse,
	GetEventByIdResponse,
	CreateEventRequest,
	CreateEventResponse,
	UpdateEventRequest,
	UpdateEventResponse,
	GetEventBannerUploadFileUrlRequest,
	GetEventLogoUploadFileUrlRequest,
	FileUploadResponse,
	GetTurnoverEventsRequest,
	TurnoverEventListResponse,
	TurnoverEventData,
	CreateTurnoverEventRequest,
	UpdateTurnoverEventRequest,
	UpdateTurnoverEventStatusRequest,
	TurnoverEventClaimListResponse,
} from '../../type'

// Custom banner events API
export const getEvents = async (
	request: GetEventsRequest,
): Promise<GetEventsResponse> => {
	const response = await axiosInstance.get<GetEventsResponse>('/admin/events', {
		params: request,
	})
	return response.data
}

// Turnover events API
export const getTurnoverEvents = async (
	request: GetTurnoverEventsRequest,
): Promise<TurnoverEventListResponse> => {
	const response = await axiosInstance.get<TurnoverEventListResponse>(
		'/admin/turnover-events',
		{ params: request },
	)
	return response.data
}

export const getTurnoverEventById = async (
	id: string,
): Promise<TurnoverEventData> => {
	const response = await axiosInstance.get<TurnoverEventData>(
		`/admin/turnover-events/${id}`,
	)
	return response.data
}

export const createTurnoverEvent = async (
	request: CreateTurnoverEventRequest,
): Promise<TurnoverEventData> => {
	const response = await axiosInstance.post<TurnoverEventData>(
		'/admin/turnover-events',
		request,
	)
	return response.data
}

export const updateTurnoverEvent = async (
	id: string,
	request: UpdateTurnoverEventRequest,
): Promise<TurnoverEventData> => {
	const response = await axiosInstance.patch<TurnoverEventData>(
		`/admin/turnover-events/${id}`,
		request,
	)
	return response.data
}

export const updateTurnoverEventStatus = async (
	id: string,
	request: UpdateTurnoverEventStatusRequest,
): Promise<TurnoverEventData> => {
	const response = await axiosInstance.patch<TurnoverEventData>(
		`/admin/turnover-events/${id}/status`,
		request,
	)
	return response.data
}

export const deleteTurnoverEvent = async (id: string): Promise<void> => {
	await axiosInstance.delete(`/admin/turnover-events/${id}`)
}

export const getTurnoverEventClaims = async (
	id: string,
	request: { take: number; skip: number; playerName?: string },
): Promise<TurnoverEventClaimListResponse> => {
	const response = await axiosInstance.get<TurnoverEventClaimListResponse>(
		`/admin/turnover-events/${id}/claims`,
		{ params: request },
	)
	return response.data
}

export const getEventById = async (
	id: string,
): Promise<GetEventByIdResponse> => {
	const response = await axiosInstance.get<GetEventByIdResponse>(
		`/admin/events/${id}`,
	)
	return response.data
}

export const createEvent = async (
	request: CreateEventRequest,
): Promise<CreateEventResponse> => {
	const response = await axiosInstance.post<CreateEventResponse>(
		'/admin/events',
		request,
	)
	return response.data
}

export const updateEvent = async (
	id: string,
	request: UpdateEventRequest,
): Promise<UpdateEventResponse> => {
	const response = await axiosInstance.patch<UpdateEventResponse>(
		`/admin/events/${id}`,
		request,
	)
	return response.data
}

export const deleteEvent = async (id: string): Promise<void> => {
	const response = await axiosInstance.delete<void>(`/admin/events/${id}`)
	return response.data
}

// File upload services
export const getEventBannerUploadFileUrl = async (
	request: GetEventBannerUploadFileUrlRequest,
): Promise<FileUploadResponse> => {
	const response = await axiosInstance.post<FileUploadResponse>(
		'/admin/file/get-event-banner-upload-file-url',
		request.payload,
	)
	return response.data
}

export const getEventLogoUploadFileUrl = async (
	request: GetEventLogoUploadFileUrlRequest,
): Promise<FileUploadResponse> => {
	const response = await axiosInstance.post<FileUploadResponse>(
		'/admin/file/get-event-logo-upload-file-url',
		request.payload,
	)
	return response.data
}
